import React, { useEffect, useState, useRef } from 'react'
import Seo from '../../../components/common/Seo'
import Sidebar from '../../../components/rsldashboard/common/Sidebar'
import Header from '../../../components/header/header-rslhome'
import ProfileButton from "../../../components/buttonWithArrow/profileButton";
import SettingsTabs from '../../../components/rsldashboard/db-cardDetails/components/index'
import Footer from '../../../components/rsldashboard/common/Footer'
import AddCardIcon from '@mui/icons-material/AddCard'
import {
  addCardDetails,
  checkAuthDetails,
  getWalletDetails,
  getWalletRecharge,
  getWalletRechargeCheck
} from '../../../redux/slices/cards'
import { useDispatch, useSelector } from '../../../redux/store'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Button, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import Skeleton from '@mui/material/Skeleton'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import DoneIcon from '@mui/icons-material/Done';
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Slide, Box, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import WalletRecharge from '../../../components/walletRecharge'
import Image from "next/image";
import { CurrencySimple, useResponsiveValue } from "../../../utils/helper";
import { fetchSeoByPage } from '../../../lib/seoHelper';

const ErrorDialog = ({ status, open, onClose, message }) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby='error-dialog-title'
    aria-describedby='error-dialog-description'
  >
    <DialogContent
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      }}
    >
      {
        status ? <DoneIcon style={{ color: 'green', fontSize: 40, marginBottom: 10 }} /> : <ErrorOutlineIcon
          style={{ color: 'red', fontSize: 40, marginBottom: 10 }}
        />
      }

      <Typography variant='body1'>{message}</Typography>
    </DialogContent>
    <DialogActions style={{ justifyContent: 'center' }}>
      <Button onClick={onClose} color='primary'>
        OK
      </Button>
    </DialogActions>
  </Dialog>
)

const Index = ({ meta }) => {
  const dispatch = useDispatch()
  const [userId, setUserId] = useState(null)
  const [loading, setLoading] = useState(false)
  const [loadingRecharge, setLoadingRecharge] = useState(false)
  const [minAmount, setMinAmount] = useState(true);
  const [maxAmount, setMaxAmount] = useState(true);
  const [cardList, setCardList] = useState([]);
  const [cardReq, setCardReq] = useState({
    paymentOption: "4",// 4-new card, 3-saved card
    transRef: null
  });
  const [orderUrl, setOrderUrl] = useState(null)
  const {
    addCardDetailsNew,
    checkAuthDetailsNew,
    walletDetails,
    walletRecharge,
    walletRechargeCheck
  } = useSelector(state => state.cards)
  const [open, setOpen] = useState(false)
  const [openWalletAmountEnter, setOpenWalletAmountEnter] = useState(false)
  const [walletAmount, setWalletAmount] = useState(0)
  const [errorMessage, setErrorMessage] = useState('')
  const [errorStatus, setErrorStatus] = useState(false);
  const responsiveFontSize = useResponsiveValue({ xs: 26, sm: 26, lg: 26 });
  console.log(walletDetails, 'walletDetails')
  console.log('walletRecharge', walletRecharge)
  // Slide-in transition effect
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />
  })
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handlePopupWalletAmount = () => {
    setOpenWalletAmountEnter(true)
  }
  const handleCloseWalletAmount = () => {
    setWalletAmount(0)
    setOpenWalletAmountEnter(false)
    setErrorMessage("");
    setErrorStatus(false);
  }

  const handleAddCard = () => {
    setLoading(true)
    if (userId) {
      dispatch(addCardDetails({ userId: userId, passenger_id: JSON.parse(sessionStorage.getItem('rslkeyId')) })).then(() => {
        setLoading(false)
      })
    }
  }

  const handleRechargeWallet = () => {
    // setLoading(true);    
    if (userId && !minAmount && !maxAmount) {
      setLoadingRecharge(true);
      let obj = { userId: userId, amount: walletAmount }
      if (cardReq.paymentOption === "3" && cardReq.transRef) {
        obj.paymentOption = cardReq.paymentOption;
        obj.transRef = cardReq.transRef;
      }
      dispatch(getWalletRecharge(obj))
    }
  }

  useEffect(() => {
    if (addCardDetailsNew && addCardDetailsNew?.status === 1) {
      sessionStorage.setItem('refKey', addCardDetailsNew.ref)
      sessionStorage.setItem('isAddCard', true)
      window.location.href = addCardDetailsNew.orderUrl
    }
  }, [addCardDetailsNew])

  useEffect(() => {
    if (walletRecharge && walletRecharge?.status === 1) {
      sessionStorage.setItem('isWalletRef', walletRecharge.ref)
      sessionStorage.setItem('isWalletRecharge', true)
      sessionStorage.setItem('walletMoney', walletAmount)
      if (walletRecharge?.paymentOption === "3") {
        // window.location.reload();
        setErrorStatus(true);
        setErrorMessage(walletRecharge.message || '');
      } else {
        setTimeout(() => {
          window.location.href = walletRecharge.orderUrl
        }, 100)
      }

    } else {
      setErrorStatus(false);
      setLoadingRecharge(false)
      setErrorMessage(walletRecharge.message || '')
    }
  }, [walletRecharge])

  // {"phone":"509409309",
  // "countryCode":"+971",
  // "name":"Fuzionest",
  // "email":"testfuzionest@gmail.com",
  // "type":"0",
  // "userId":"65217e7ca2caa906d8ff9e09",
  // "ref":"73D271035CC89184A9DDAC0C59C05AAE6DC3D9AA095CE14C4504FF028F932EE5",
  // "defValue":"1",
  // "payment_gateway_mode":"1",
  // "payment_mode":"1"}
  const rslKey = JSON.parse(sessionStorage.getItem('rslkey') || '{}')
  // const email = JSON.parse(sessionStorage.getItem('userEmail') || '{}');
  // const userName = JSON.parse(sessionStorage.getItem('userName') || '{}');
  // const phone = JSON.parse(sessionStorage.getItem('phone') || '{}');
  // const countryCode = JSON.parse(sessionStorage.getItem('countryCode') || '{}');
  // const ref = sessionStorage.getItem('refKey') || '{}';
  const isAdd = sessionStorage.getItem('isAddCard')

  useEffect(() => {
    if (isAdd) {
      setUserId(rslKey)
      // const obj = {
      //   userId: rslKey,
      //   email: email,
      //   countryCode: countryCode,
      //   phone: phone,
      //   name: userName,
      //   ref: ref,
      //   type: '0',
      //   defValue: '1',
      //   payment_mode: '1',
      //   payment_gateway_mode: '1',
      // };
      // dispatch(checkAuthDetails(obj));
      sessionStorage.removeItem('isAddCard')
    }
  }, [dispatch])

  useEffect(() => {
    const rslKey = JSON.parse(sessionStorage.getItem('rslkey'))
    setUserId(rslKey)
  }, [])

  const userDetails = {
    phone: JSON.parse(sessionStorage.getItem('phone')),
    countryCode: JSON.parse(sessionStorage.getItem('countryCode')),
    name: JSON.parse(sessionStorage.getItem('userName')),
    email: JSON.parse(sessionStorage.getItem('userEmail')),
    userId: JSON.parse(sessionStorage.getItem('rslkey')),
    passenger_id: JSON.parse(sessionStorage.getItem('rslkeyId')),
    type: 0
  }

  useEffect(() => {
    dispatch(getWalletDetails(userDetails))
  }, [])

  // Handle key events (Backspace, Arrow Navigation)
  const handleKeyDown = (e) => {
    // Prevent entering non-numeric characters, including 'e', '+', and '-'
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <>
      <Seo meta={meta} />
      {/* End Page Title */}

      <div className='header-margin'></div>

      <Header bgColor="#f6f6f6" />
      {/* End dashboard-header */}

      <div className='dashboard'>
        <div className='dashboard__sidebar bg-white scroll-bar-1'>
          <Sidebar />
        </div>
        <div
          className='offcanvas offcanvas-start'
          tabIndex='-1'
          id='carSidebar'
        >
          <div className='offcanvas-header'>
            <h5 className='offcanvas-title' id='offcanvasLabel'>
              Card Details
            </h5>

            <button
              type='button'
              className='btn-close'
              data-bs-dismiss='offcanvas'
              aria-label='Close'
            ></button>
          </div>
          {/* End offcanvas header */}

          <div className='offcanvas-body'>
            <aside className='sidebar y-gap-40  xl:d-block' style={{ marginTop: "10px" }}>
              <Sidebar enableClos={true} />
            </aside>
          </div>
          {/* End offcanvas body */}
        </div>

        <div className='dashboard__main'>
          <div className="dashboard-content">
            <div className='row' >
              <div className='row y-gap-20 justify-between items-center'>
                <div className='col-auto'>
                  <div className='d-flex items-center justify-between'>
                    <h1 className='text-30 lh-14 fw-600'>Card Details</h1>
                    <ManageAccountsIcon
                      data-bs-toggle='offcanvas'
                      data-bs-target='#carSidebar'
                      className='d-lg-none text-secondary'
                    />
                  </div>
                  <p className='text-15 text-light-1'>
                    Manage your personal information, manage security settings, and customize your experience.
                  </p>
                </div>
                {/* <div className='col-4 d-none lg:d-block'>
                  <button
                    data-bs-toggle='offcanvas'
                    data-bs-target='#carSidebar'
                    className='-blue-1 h-40 px-20 rounded-100 bg-dark-3 text-15 text-white'
                  >
                    Settings
                  </button>
                </div> */}
              </div>

              <h6 className="section-title">Wallet Details</h6>

              <div className="divider1"></div>

              <div className="wallet-row">

                <div>

                  <h6 className="card-title mb-1 card-title-gray">
                    Available Balance
                  </h6>

                  {walletDetails?.wallet_amount !== undefined ? (
                    <div className="wallet-amount">
                      {CurrencySimple(walletDetails?.wallet_amount, "#000000", responsiveFontSize, "image", null)}
                      {/* Currency Icon */}
                      {/* <Image
                        src="/img/UAE_Dirham_Symbol.svg"
                        alt="currency"
                        width={20}
                        height={30}
                        style={{ marginRight: "8px" }}
                      />

                      {walletDetails.wallet_amount} */}
                      <Image
                        src="/img/header/eye.svg"
                        alt="currency"
                        width={20}
                        height={30}
                        style={{ marginLeft: "8px" }}
                      />
                    </div>
                  ) : (
                    <Skeleton width={80} height={35} />
                  )}
                </div>


                <ProfileButton
                  label="Add Amount"
                  endIconSrc="/img/header/plus.svg"
                  onClick={handlePopupWalletAmount}
                />
              </div>

              {/* CARD DETAILS */}
              <h6 className="card-title mb-3 card-title-gray">
                Card Details
              </h6>
              <div className='text-center'>
                <SettingsTabs handleClickOpen={handleClickOpen} setCardList={setCardList} />
              </div>


            </div>
          </div>

        </div>
      </div>

      <Dialog
        open={openWalletAmountEnter}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        disableBackdropClick
        disableEscapeKeyDown
        fullWidth={true}
        maxWidth='sm'
      >
        <DialogTitle id='alert-dialog-title'>Top Up</DialogTitle>
        <DialogContent>
          <input
            type='number'
            name='amount'
            value={walletAmount}
            inputMode="numeric" // Enables numeric keypad on mobile devices
            pattern="[0-9]*" // Suggests a numeric-only keyboard
            onChange={e => {
              setMaxAmount(false);
              let value = e.target.value;

              // Remove non-numeric characters except dot
              value = value.replace(/[^0-9.]/g, "");

              // Prevent multiple dots
              if (value.split(".").length > 2) {
                return;
              }

              // Limit to two decimal places
              if (value.includes(".")) {
                const [integer, decimal] = value.split(".");
                value = `${integer}.${decimal.slice(0, 2)}`;
              }

              // Convert to number for validation
              const numericValue = parseFloat(value) || 0;

              // Enforce limits (0 - 5000)
              if (numericValue > 5000) {
                setMaxAmount(true);
                return; // Stop updating if value exceeds 5000
              }

              setMinAmount(numericValue < 12 ? true : false)
              setMaxAmount(numericValue > 5000 ? true : false)
              setWalletAmount(value)
            }}

            onKeyDown={(e) => handleKeyDown(e)}
            style={{
              padding: "0px 10px"
            }}
            className='border-light text-dark-1 h-50 rounded-8'
          />
          <p
            style={{
              color: minAmount || maxAmount ? "red" : "white",
              fontSize: "12px",
            }}
          >
            {minAmount
              ? "Minimum amount should be 12 AED"
              : maxAmount
                ? "Maximum amount should be 5000 AED"
                : "Valid"}
          </p>
          {
            cardList?.length > 0 &&
            <WalletRecharge getCardList={cardList} cardReq={cardReq} setCardReq={setCardReq} />
          }

        </DialogContent>

        <DialogActions>
          {loadingRecharge ? (
            ''
          ) : (
            <Button
              onClick={handleCloseWalletAmount}
              variant='contained'
              className='button-disagree'
            >
              Cancel
            </Button>
          )}

          <Button
            variant='contained'
            autoFocus
            onClick={handleRechargeWallet}
            className='button-agree'
          >
            {loadingRecharge ? (
              <CircularProgress size={24} sx={{ color: '#ffffff' }} />
            ) : (
              'Recharge'
            )}
          </Button>
        </DialogActions>
        <ErrorDialog
          status={errorStatus}
          open={!!errorMessage}
          onClose={() => {
            if (errorStatus) {
              window.location.reload();
            } else {
              setErrorMessage('');
            }
          }}
          message={errorMessage}
        />
      </Dialog>

      <Dialog
        open={open}
        onClose={handleClose}
      // TransitionComponent={Transition}
      // PaperProps={{
      //   className: isMobile ? "dialog-fullscreen" : "dialog-container",
      // }}
      >
        {/* Header with Warning Icon */}
        <DialogTitle className='dialog-header'>
          <Box className='dialog-header'>
            <WarningAmberIcon className='dialog-icon' />
            <span className='dialog-title'>Confirmation Required</span>
          </Box>
        </DialogTitle>

        {/* Dialog Content */}
        <DialogContent>
          <DialogContentText className='dialog-content-text'>
            Are you sure you want to add a new card?
          </DialogContentText>
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions className='dialog-actions'>
          {/* Disagree Button - Styled in Red */}
          <Button
            onClick={handleClose}
            variant='contained'
            className='button-disagree'
          >
            Disagree
          </Button>

          {/* Agree Button with Loading Spinner */}
          <Button
            variant='contained'
            autoFocus
            onClick={handleAddCard}
            disabled={loading}
            className='button-agree'
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: '#ffffff' }} />
            ) : (
              'Agree'
            )}
          </Button>
        </DialogActions>
      </Dialog>
      {/* End dashbaord content */}
    </>
  )
}

export default Index

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}